import { Colors, Services, isEmpty } from '@sigma-frontend-libs/commons'
import { DICTIONARIES_STATUSES } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components, icons, states } from '@/utils'

import button from '@/components/button'
import buttonConfirmRemove from '@/components/button/confirm/remove'
import pagination from '@/components/pagination'
import preloader from '@/components/preloader'
import form from '@/components/services/operatorGroups/form'
import sticker from '@/components/sticker'

const columns = [ 'operator', 'group', 'mcc', 'mnc' ]

function renderSearchField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.search,
        label: this.getTranslate('commons.labels.search'),
        loading: this.restData[Services.operatorGroups].find.state === states.loading,
        disabled: !this.restData[Services.operatorGroups].find.filter.$search && this.restData[Services.operatorGroups].find.pagination.total === 0,
        dense: true,
        details: false,
        clearable: true
      },
      on: {
        input: event => {
          this.search = event
        }
      }
    }
  )
}
function renderSearchButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.search'),
        mode: buttonModes.flat,
        color: Colors.primary,
        loading: this.loading,
        disabled: isEmpty(this.search) || this.restData[Services.operatorGroups].find.state === states.loading,
        type: 'submit'
      }
    }
  )
}
function renderForm(h) {
  return h(
    components.form,
    {
      class: `${Services.operatorGroups}-header__form`,
      on: {
        submit: () => {
          return this.searchHandler()
        }
      }
    },
    [
      renderSearchField.call(this, h),
      renderSearchButton.call(this, h)
    ]
  )
}
function renderCreateButton(h) {
  if (this.viewport.size.width >= 600) {
    return h(
      button,
      {
        props: {
          label: this.getTranslate('misc.buttons.add'),
          color: Colors.secondary,
          mode: buttonModes.flat,
          disabled: !this.canCreate
        },
        on: {
          click: () => {
            this.showDialog = true
          }
        }
      }
    )
  }

  return h(
    components['list-item'],
    {
      props: {
        label: this.getTranslate('misc.buttons.add'),
        icon: icons.add,
        iconColor: Colors.secondary
      },
      on: {
        click: () => {
          this.showDialog = true
        }
      }
    }
  )
}
function renderRemoveDictionaryButton(h) {
  if (this.viewport.size.width < 780) {
    if (this.canRemove) {
      let component = components['list-item']
      if (this.viewport.size.width >= 600) {
        component = 'button'
      }

      return h(
        buttonConfirmRemove,
        {
          props: {
            component,
            showIcon: this.viewport.size.width < 600,
            content: this.getTranslate(`${Services.dictionaries}.contents.confirm.remove.dictionary`, { title: this.dictionary.id }),
            disabled: this.dictionary.status === DICTIONARIES_STATUSES.activated,
            callback: () => {
              this.removeCallback()
            }
          }
        }
      )
    }
  }
}
function renderMenuActions(h) {
  return h(
    components.menu,
    {
      class: { 'hover-child': this.viewport.breakpoint.mdUp && !this.showMenu },
      props: {
        value: this.showMenu,
        rounded: true,
        offsetDistance: 8
      },
      on: {
        input: event => {
          this.showMenu = event
        }
      }
    },
    [
      h(
        button,
        {
          props: {
            icon: icons.more_vert,
            mode: buttonModes.flat,
            disabled: this.loading
          },
          slot: 'activator'
        }
      ),
      h(
        components.list,
        {
          props: {
            dense: true,
            rounded: true
          }
        },
        [
          renderCreateButton.call(this, h),
          renderRemoveDictionaryButton.call(this, h)
        ]
      )
    ]
  )
}
function renderActions(h) {
  if (this.viewport.size.width >= 600) {
    return h(
      'div',
      {
        class: `${Services.operatorGroups}-header__actions`
      },
      [
        renderCreateButton.call(this, h),
        renderRemoveDictionaryButton.call(this, h)
      ]
    )
  }

  return renderMenuActions.call(this, h)
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${Services.operatorGroups}-header`
    },
    [
      renderForm.call(this, h),
      renderActions.call(this, h)
    ]
  )
}

function renderDivider(h) {
  if (Array.isArray(this.restData[Services.operatorGroups].find.data) && this.restData[Services.operatorGroups].find.data.length) {
    return h('g-divider')
  }
}

function renderPagination(h) {
  let chunk = 5
  if (this.viewport.breakpoint.smDown) {
    chunk = 2
  }

  return h(
    'div',
    {
      class: 'fjcfe pa-2'
    },
    [
      h(
        pagination,
        {
          props: {
            value: this.restData[Services.operatorGroups].find.pagination,
            chunk,
            service: Services.operatorGroups
          },
          on: {
            input: event => {
              this.restData[Services.operatorGroups].find.pagination = event
            }
          }
        }
      )
    ]
  )
}

function renderRemoveButton(h, item) {
  return h(
    buttonConfirmRemove,
    {
      class: { 'hover-child': this.viewport.breakpoint.mdUp },
      props: {
        showIcon: false,
        disabled: this.restData[Services.operatorGroups].remove.state === states.loading || !this.canRemove,
        callback: () => {
          this.rest[Services.operatorGroups].remove(item.id)
        }
      }
    }
  )
}
function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder pa-5'
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.restData[Services.operatorGroups].find.state === states.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderItemColumns(h, item) {
  return h(
    'div',
    {
      class: `${Services.operatorGroups}-item__columns`
    },
    [
      columns.map(column => {
        return h(
          sticker,
          {
            props: {
              value: item[column],
              label: this.getTranslate(`${Services.dictionaries}.titles.${column}`),
              copy: true
            }
          }
        )
      })
    ]
  )
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: {
        'hover-parent hover-parent--opacity': true,
        [`service-template-item ${Services.operatorGroups}-item`]: true
      }
    },
    [
      renderItemColumns.call(this, h, item),
      renderRemoveButton.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  return h(
    'div',
    {
      class: `${Services.operatorGroups}-items`
    },
    [
      this.restData[Services.operatorGroups].find.data.map(item => {
        return renderItem.call(this, h, item)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderBody(h) {
  if (this.restData[Services.operatorGroups].find.pagination.total > 0) {
    return renderItems.call(this, h)
  } else {
    switch (this.restData[Services.operatorGroups].find.state) {
      case states.loading: return renderPreloader.call(this, h)
      case states.ready:
      default: return h(components.empty)
    }
  }
}

function renderCreateDialog(h) {
  if (this.canCreate) {
    return h(
      components.dialog,
      {
        props: {
          title: this.getTranslate('dictionaries.titles.createGroup'),
          value: this.showDialog,
          maxWidth: 400
        },
        on: {
          input: event => {
            this.showDialog = event
          }
        }
      },
      [
        h(
          form,
          {
            props: {
              value: this.restData[Services.operatorGroups].create.data,
              dictionary: this.dictionary
            },
            on: {
              input: event => {
                this.restData[Services.operatorGroups].create.data = event
              },
              validation: event => {
                this.restData[Services.operatorGroups].create.isValid = event
              }
            }
          }
        ),
        h(
          'div',
          {
            class: 'dialog__footer',
            slot: 'footer'
          },
          [
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.close'),
                  mode: buttonModes.flat
                },
                on: {
                  click: () => {
                    this.showDialog = false
                  }
                }
              }
            ),
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.create'),
                  loading: this.restData[Services.operatorGroups].create.state === states.loading,
                  disabled: !this.canCreate || !this.restData[Services.operatorGroups].create.isValid,
                  color: Colors.primary
                },
                on: {
                  click: () => {
                    this.createGroup()
                  }
                }
              }
            )
          ]
        )
      ]
    )
  }
}

export default function(h) {
  if (this.dictionary.id === this.restData[Services.operatorGroups].find.filter.DictionaryId) {
    if (this.isCorrectStatus) {
      return h(
        components.card,
        {
          props: {
            rounded: true,
            outline: true
          }
        },
        [
          renderHeader.call(this, h),
          renderDivider.call(this, h),
          renderPagination.call(this, h),
          renderDivider.call(this, h),
          renderBody.call(this, h),
          renderDivider.call(this, h),
          renderPagination.call(this, h),
          renderCreateDialog.call(this, h)
        ]
      )
    }
  }
}
